import { Box, Grid, Theme, Typography } from '@material-ui/core'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import AddOligoButton from './AddOligoButton'
import DeleteAllOligos from './DeleteAllOligos'

const useStyles = makeStyles((theme: Theme) => {
  return {
    boxBorder: {
      boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
      marginTop: theme.spacing(30),
      padding: theme.spacing(4),
    },
    title: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(2),
    },
    dividerMargin: {
      marginBottom: theme.spacing(4),
    },
    bodyContent: {
      fontSize: theme.typography.pxToRem(12),
      marginBottom: theme.spacing(4),
    },
  }
})

interface LeftSideBottomBarProps {
  title: React.ReactElement
  bodyContent: React.ReactElement
  handleAddOligo: () => void
  disableAddNextLinks: boolean
  enableDeleteAll?: boolean
  handleDeleteAll?: () => void
  oligoCount?: number
}

const LeftSideBottomBar: React.FC<LeftSideBottomBarProps> = ({
  title,
  bodyContent,
  handleAddOligo,
  disableAddNextLinks,
  enableDeleteAll,
  handleDeleteAll,
  oligoCount = 0,
}) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.boxBorder}>
      <Grid item xs={12}>
        <Typography className={classes.title}>{title}</Typography>
        <Divider color="primary" className={classes.dividerMargin} />
      </Grid>
      <Grid item xs={12}>
        <Box className={classes.bodyContent}>{bodyContent}</Box>
        <Divider color="primary" className={classes.dividerMargin} />
      </Grid>
      <AddOligoButton
        handleAddOligo={handleAddOligo}
        disabled={disableAddNextLinks}
      />
      {handleDeleteAll && (
        <DeleteAllOligos
          handleDeleteAll={handleDeleteAll}
          disabled={!enableDeleteAll}
          oligoCount={oligoCount}
        />
      )}
    </Grid>
  )
}

export default LeftSideBottomBar
